module.exports = __webpack_public_path__ + "static/media/cornelio_procopio.2ca71511.jpg";